<template>
  <div class="user-cards-container is-hidden-touch is-hidden-desktop-only" :class="{ 'is-IE': isIE11 }">
    <collect-pin v-if="showPinProjectView" class="collect-pin" :project="project" :pinSize="125"></collect-pin>
    <div v-if="!edit">
      <div @mousedown="move('up')" :class="{'hidden': !showUp}" class="button-container">
        <div><i class="fal fa-chevron-up fa"></i></div>
      </div>
      <div ref="cardsContainer" class="user-cards"
            :class="{'user-cards_auditorium': this.isAuditoriumStory}"
            @scroll="handleScroll">
        <user-card v-for="user in this.members" :user="user" :key="user.name"></user-card>
      </div>
      <div :class="{'hidden': !showDown}" @mousedown="move('down')" class="button-container down-button">
        <div><i class="fal fa-chevron-down fa"></i></div>
      </div>
    </div>
  </div>
</template>

<script>

import UserCard from './UserCard'

import CollectPin from '@/components/Controls/CollectPin'

import userAgent from '@/libs/user-agent'

export default {
  components: {
    UserCard,
    CollectPin
  },
  props: ['project', 'edit', 'showPinProjectView'],
  mixins: [],
  data: function () {
    return {
      members: [],
      scrollPosition: 0,
      hasScrolledToBottom: false,
      scrollStarted: false,
      showUp: false,
      showDown: false
    }
  },
  watch: {
    project: function () {
      this.fetchMembers()
    }
  },
  mounted: function () {
    this.fetchMembers()
  },
  computed: {
    isIE11: function () {
      return userAgent.isIE11()
    },
    isAuditoriumStory: function () {
      return this.$route.path.includes('auditoriumStory')
    }
  },
  methods: {
    fetchMembers: function () {
      if (!this.project || !this.project.id) {
        return
      }
      this.$store.dispatch('getMembers', { project: this.project, limit: 10, offset: 0 }).then((response) => {
        this.members.push.apply(this.members, response.members)
        this.filterMembers()
        if (this.members.length > 2) {
          this.showDown = true
        }
      })
    },
    filterMembers: function () {
      this.members = this.members.map(function (users) {
        if (users.role === 'co-owner' || users.role === 'owner') {
          return users.user
        }
      })
      this.members = this.members.filter(function (users) {
        if (users !== undefined) {
          return users
        }
      })
    },
    move: function (value) {
      if (value === 'down') {
        this.scrollPosition = this.scrollPosition + 250
      }
      if (value === 'up') {
        this.scrollPosition = this.scrollPosition - 250
      }
      if (this.scrollPosition < 0) {
        this.scrollPosition = 0
      }
      this.$refs.cardsContainer.scrollTop = this.scrollPosition
    },
    handleScroll: function (el) {
      if (el.srcElement.scrollTop > 1) {
        this.showUp = true
      } else {
        this.showUp = false
      }
      if ((el.srcElement.offsetHeight + el.srcElement.scrollTop) >= el.srcElement.scrollHeight) {
        this.showDown = false
      } else {
        this.showDown = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.user-cards-container {
  top: calc(75px + 1rem);
  right: calc(100vw/2 - 400px - 200px - 1.5rem);
  position: fixed;
  z-index: 5;
  margin-left: 1rem;
}

.collect-pin {
  display: flex;
  justify-content: space-around;
  margin: 1.25rem auto 0;
}

button {
  width: 100%;
  height: 1.5rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  color: $primary;
  i {
    font-size: 1rem;
  }
}

.user-cards {
  height: 75vh;
  overflow: hidden;
  scroll-behavior: smooth;

  &_auditorium {
    overflow-y: hidden;
    overflow-x: unset;
  }
}

.is-IE {
  right: calc(100vw/2 - 400px - 200px - 16px);
}

.scroll-button {
  height: 100%;
  width: 2rem;
  pointer-events: auto;
  align-items: center;
  justify-content: center;
  background-color: black;
  padding: 0.6rem 0.1rem;
  position: absolute;
  opacity: 0.4;
  transition: 0.2s;
  &:hover {
    opacity: 0.7;
  }
}

.button-container {
  display: flex;
  justify-content: center;
  background: black;
  opacity: 0.4;
  i {
    color: white;
  }
  &:hover {
    opacity: 0.7;
  }
}

.hidden {
  visibility: hidden;
}

</style>
